import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-switchable-label-qty',
    templateUrl: './switchable-label-qty.component.html',
    styleUrls: [
        '../label-qty/label-qty.component.scss',
        './switchable-label-qty.component.scss'
    ],
    standalone: false
})
export class SwitchableLabelQtyComponent
{
    @Input() active: boolean;
    @Input() label: string;
    @Input() counter?: number;
    @Input() title: string = '';
}
